import { Checkbox } from '@own/fds-react';
import { CheckboxProps } from '@own/fds-react/dist/types/checkbox.types';
import './fm-checkbox.scss';
export const FmCheckbox = (props: CheckboxProps) => {
    return <Checkbox {...props} />;
};
